/**
 * The customer draft: what the captain typed on the Customer screen, before any
 * order exists.
 *
 * It is a DRAFT in the §39.1/§14 sense — nothing is persisted anywhere
 * authoritative until the first item creates the order, and walking away must
 * leave no trace. It used to travel in router `location.state`, which has two
 * failure modes this module exists to remove: a reload on the menu screen
 * silently dropped the guest (route state does not survive reload — spec Test A
 * requires it to), and deep-linking to the menu never had a draft at all.
 *
 * sessionStorage, not localStorage: a draft is scoped to this device and this
 * session. Keyed per table so two tabs on two tables cannot cross-pollinate.
 */

const key = tableId => `vibez-captain-draft:${tableId}`;

export function saveCustomerDraft(tableId, draft) {
  try {
    sessionStorage.setItem(key(tableId), JSON.stringify(draft));
  } catch {
    /* storage full/blocked — the draft degrades to in-memory route state */
  }
}

export function loadCustomerDraft(tableId) {
  try {
    const raw = sessionStorage.getItem(key(tableId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Called when the draft is consumed (order started) or explicitly discarded. */
export function clearCustomerDraft(tableId) {
  try {
    sessionStorage.removeItem(key(tableId));
  } catch {
    /* nothing to clear */
  }
}
